import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { CnaeService } from './../../../services/cnae.service';
import { Cnae } from '../../../models/Cnae.model';
import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DropDownList } from '../../../models/DropDownList.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import {​​​ ErrorHandlerProvider }​​​ from'../../../shared/providers/errorHandler.provider';
@Component({
    selector: 'app-cnaes-create',
    templateUrl: './cnaes-create.component.html',
    styleUrls: ['./cnaes-create.component.css']
})
export class CnaeCreateComponent implements OnInit {
    cnaeForm: FormGroup;
    loading: boolean;
    cnae: Cnae = new Cnae();
    cnaesSap = [];
    commonHelper: CommonHelper = new CommonHelper();
    SapItemType = SapItemType;

    dropDownCnaesList: DropDownList[] = new Array<DropDownList>();
    selectedCnae: DropDownList[] = new Array<DropDownList>();
    dropDownCnaesSettings = {};

    constructor(
        private formBuilder: FormBuilder,
        private cnaeService: CnaeService,
        private router: Router,
        public toastr: ToastsManager,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.cnaeForm = this.formBuilder.group({
            name: [null, Validators.required],
            type: [null, [this.validateSelectOption]]
        });

        this.cnaesSap = await this.cnaeService.getAllCnaesSap();

        this.dropDownCnaesList = this.cnaesSap.map(item => ({
            id: item.sapKey, itemName: `${item.cnae} - ${item.description}`
        }));

        this.dropDownCnaesSettings = this.commonHelper.getDropDownSettings(true, 'CNAEs', false, '', '', true, null, '', true);

        this.loading = false;
    }

    async Onsave() {
        try {
            if(this.selectedCnae.length > 0) {
                const cnaeSelected = this.cnaesSap.find(c => c.sapKey === this.selectedCnae[0].id);
                this.cnae.cnae = cnaeSelected.cnae;
                this.cnae.sapKey = cnaeSelected.sapKey;
            }

            if(this.cnae.name.length > 100) 
                return this.toastr.warning('O nome do Item é longo demais, permitido apenas 100 caracteres!', 'Erro no módulo CNAE e Itens.');

            let response = await this.cnaeService.create(this.cnae);

            if (response._id) {
                this.toastr.success('Cnae criado com sucesso!');
            } else {
                this.errorHandler.interceptError(response, 'CNAEs e Itens!');
            }

            this.router.navigate(['/cnaes']);

        } catch (err) {
            console.log(err);
            this.router.navigate(['/cnaes']);
            this.errorHandler.interceptError(err, 'CNAEs e Itens!');
        }

    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == 'undefined' || control.value == undefined)
            return {type: true};
        return null;
    }

    cancel() {
        this.cnae = new Cnae();
        this.selectedCnae = [];
    }

    OnClear() {
        this.cnae = new Cnae();
    }

    verifyValidTouched(fieldName) {
        return !this.cnaeForm.get(fieldName).valid && this.cnaeForm.get(fieldName).touched;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    changeType() {
        if(this.cnae.type != SapItemType.CnaeBilling && this.cnae.type != SapItemType.CnaeConsultant)
            this.dropDownCnaesSettings = { ...this.dropDownCnaesSettings, disabled: true };
        else
            this.dropDownCnaesSettings = { ...this.dropDownCnaesSettings, disabled: false };
        this.selectedCnae = [];
    }

}



// WEBPACK FOOTER //
// ./src/app/views/cnaes/cnaes-create/cnaes-create.component.ts